// @ts-strict-ignore
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SecurityContext,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { SohoAlertDirective, SohoBusyIndicatorDirective } from 'ids-enterprise-ng';
import { LMFieldPickerService } from '@modal/field-picker/services';
import { Observable, Subject, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as urltemplate from 'url-template';
import { catchError, debounceTime } from 'rxjs/operators';
import { LMUniqueIdService } from '@utils/lm-unique-id.service';
import {
  LMFieldPickerResponse,
  LMFieldPickerSelectOptions,
  LMFieldPickerSelectResponse,
  LMFieldPickerView
} from '@modal/field-picker/lm-field-picker';
import { LMConfigurationService } from '@app/services';
import { DomSanitizer } from '@angular/platform-browser';

/*
* TODO: Refactor once create report is implemented
 */

@Component({
  selector:    'lm-filter-builder-field-lookup',
  templateUrl: './lm-filter-builder-field-lookup.component.html',
  styleUrls:   [ './lm-filter-builder-field-lookup.component.scss' ]
})
export class LMFilterBuilderFieldLookupComponent implements OnInit {

  @ViewChild(SohoBusyIndicatorDirective) busyIndicator: SohoBusyIndicatorDirective;
  @ViewChild('modalPlaceholder', { read: ViewContainerRef }) modalPlaceholder: ViewContainerRef;
  @ViewChild(SohoAlertDirective) fieldAlert: SohoAlertDirective;

  @Input() id: string;
  @Input() qualifier: Qualifier;
  @Input() businessClass: string;
  @Input() includeAuditFields: boolean;
  @Input() lookupUrl: string;
  @Input() index: number;
  @Input() position: string;
  @Input() mode: LMFieldPickerView | 'InstanceSelection';
  @Input() fieldSearchUrl: string;
  @Input() lplValidationUrl: string;

  @Output() fieldSelectionEvent = new EventEmitter<LMFieldLookUpEvent>();

  modelChanged: Subject<string> = new Subject<string>();

  fieldId: string;

  constructor(private lmFieldPickerService: LMFieldPickerService,
    private http: HttpClient,
    private lmUniqueIdService: LMUniqueIdService,
    private lmConfigurationService: LMConfigurationService,
    private domSanitizer: DomSanitizer) {
  }

  /*onGetFieldQualifier = (e, lookup) => {
    this.busyIndicator.activated = true;
    this.lmFieldPickerService.openFieldPickerDialog(this.modalPlaceholder, this.businessClass, this.lookupUrl, this.mode)
      .subscribe((result: UIFieldSpec) => {
        if (result) {
          this.handleRowSelectionEvent(result);
        }
        this.busyIndicator.activated = false;
      });
  };*/

  ngOnInit(): void {

    this.fieldId = this.lmUniqueIdService.uniqueId([ this.id, this.index.toString() ]);

    this.modelChanged.pipe(
      debounceTime(10)).subscribe( input => {

      this.qualifier.updated = true;
      this.qualifier.validated = false;
      this.qualifier.isValid = false;

      if (this.qualifier.text === '') {
        this.fieldAlert.removeAllMessages();
        this.qualifier.validated = true;
        this.qualifier.isValid = true;
        this.fieldSelectionEvent.emit({ qualifier: this.qualifier });
      } else {
        this.fieldIsValid(this.qualifier.text)
          .subscribe((response: any) => {
            if (response.lplStatus === 'LPL_VALID' || this.qualifier.type === 'OTO_RELATION' || this.qualifier.type === 'OTM_RELATION') {
              this.fieldAlert.removeAllMessages();
              this.qualifier.isValid = true;
              const type = response?.message?.fieldType ? response.message.fieldType : 'TEXT';
              this.qualifier.type = type;
              this.fieldSelectionEvent.emit({ qualifier: this.qualifier });
            } else {
              this.qualifier.text = this.domSanitizer.sanitize(SecurityContext.HTML, this.qualifier.text);
              this.fieldAlert.addInlineMessage(this.domSanitizer.sanitize(SecurityContext.HTML, response.message.error), 'error');
              this.qualifier.isValid = false;
            }
            this.qualifier.validated = true;
          });
      }
    });
  }

  private handleRowSelectionEvent(response: LMFieldPickerSelectResponse) {
    if (response) {
      this.qualifier.index = this.index;
      this.qualifier.position = this.position;

      const uiFieldSpec = response.uiFieldSpec;
      const fieldName = response.fieldName;

      this.qualifier.text = fieldName;
      this.qualifier.type = uiFieldSpec.fieldType;  // this should use the lmrkFieldType
      this.qualifier.validated = true;
      this.qualifier.isValid = true;

      this.fieldAlert.removeAllMessages();

      this.fieldSelectionEvent.emit({ qualifier: this.qualifier });
    }
  }

  autoCompleteSource = ((searchTerm: string, response: SohoAutoCompleteResponseFunction) => {
    this.searchField(searchTerm)
      .subscribe((fieldPickerResponse: LMFieldPickerResponse) => {
        let uiFieldSpecNames;
        if (fieldPickerResponse.data) {
          uiFieldSpecNames = fieldPickerResponse.data.map(uiFieldSpec => {
            const fieldName = this.lmFieldPickerService.getUIFieldSpecSearchName(uiFieldSpec);
            return {
              value: fieldName,
              label: fieldName,
              fieldType: uiFieldSpec.fieldType
            };
          });

          response(searchTerm, uiFieldSpecNames);
        }
      });
  });

  onGetFieldQualifier($event: Event) {
    const options: LMFieldPickerSelectOptions = {
      view: this.mode,
      businessClass: this.businessClass,
      includeAuditFields: this.includeAuditFields
    };
    this.lmFieldPickerService.openFieldPickerDialog(options, this.lookupUrl, this.modalPlaceholder)
      .subscribe((result) => {
        this.handleRowSelectionEvent(result);
      });
  }

  searchField(searchTerm: string): Observable<LMFieldPickerResponse> {
    const formRequest: any = {
      lookupField: searchTerm
    };

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json;charset=utf-8');

    const compiledUrlTemplate = urltemplate.parse(this.fieldSearchUrl);

    const url = compiledUrlTemplate.expand({ resourceId: this.businessClass });
    return this.lmConfigurationService.searchField(searchTerm, url, this.businessClass, 'InstanceSelection');
  }

  private _handleError(error: Response) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    return throwError(error || 'Server error');
  }

  onAutoCompleteSelected(event: Event) {
    this.fieldIsValid(event[ 2 ].label)
      .subscribe((response: any) => {
        if (response.lplStatus === 'LPL_VALID' || event[ 2 ].value === 'OTO_RELATION' || event[ 2 ].value === 'OTM_RELATION') {
          this.fieldAlert.removeAllMessages();
          this.qualifier.text = event[ 2 ].label;
          // The value attribute needs to be unique which is why fieldName and fieldType is combined.
          this.qualifier.type = event[ 2 ].fieldType;
          this.qualifier.isValid = true;
          this.fieldSelectionEvent.emit({ qualifier: this.qualifier });
        } else {
          this.qualifier.text = this.domSanitizer.sanitize(SecurityContext.HTML, this.qualifier.text);
          this.fieldAlert.addInlineMessage(this.domSanitizer.sanitize(SecurityContext.HTML, response.message.error), 'error');
          this.qualifier.isValid = false;
        }
        this.qualifier.validated = true;
      });
  }

  fieldIsValid(value: string): Observable<Response> {
    const formRequest: any = {
      requestType: 'validateCompute',
      param1: this.businessClass,
      param2: value,
      param3: this.businessClass,
    };

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json;charset=utf-8');

    const compiledUrlTemplate = urltemplate.parse(this.lplValidationUrl);

    const url = compiledUrlTemplate.expand({ resourceId: this.businessClass });

    return <Observable<Response>> this.http.post(url, JSON.stringify(formRequest), { headers }).pipe(
      catchError(error => this._handleError(error)));
  }

  onChange(event: Event) {
    this.modelChanged.next((<HTMLInputElement>event.target).value);
  }

  validateField() {
    if (this.qualifier.text === '') {
      this.fieldAlert.removeAllMessages();
      this.qualifier.validated = true;
      this.qualifier.isValid = true;
      this.fieldSelectionEvent.emit({ qualifier: this.qualifier });
    } else {
      this.fieldIsValid(this.qualifier.text)
        .subscribe((response: any) => {
          if (response.lplStatus === 'LPL_VALID'  || this.qualifier.type === 'OTO_RELATION' || this.qualifier.type === 'OTM_RELATION') {
            this.fieldAlert.removeAllMessages();
            this.qualifier.isValid = true;

            // lets use this is if it exists!
            if (response?.message?.fieldType) {
              this.qualifier.type = response.message.fieldType;
            }

            // if no type, then lets punt and use TEXT
            if (this.qualifier.type === undefined) {
              this.qualifier.type = 'TEXT';
            }
            this.fieldSelectionEvent.emit({ qualifier: this.qualifier });
          } else {
            this.qualifier.text = this.domSanitizer.sanitize(SecurityContext.HTML, this.qualifier.text);
            this.fieldAlert.addInlineMessage(this.domSanitizer.sanitize(SecurityContext.HTML, response.message.error), 'error');
            this.qualifier.isValid = false;
          }
          this.qualifier.validated = true;
        });
    }
  }
}
